import { modals as rumodals } from "src/i18n/dictionaries/ru/modals";

export const modals: Record<keyof typeof rumodals, string> = {
  // ── Общие подписи платёжных модалок ──────────────────
  "components.routes.modals.payment.minimum": "Minimum:",
  "components.routes.modals.payment.network": "Network:",

  // ── Пополнение (выбор способа) ───────────────────────
  "components.routes.modals.Deposit.usdt": "Deposit USDT (TRC20)",
  "components.routes.modals.Deposit.crypto": "Deposit with crypto",
  "components.routes.modals.Deposit.rub": "Deposit in RUB (coming soon)",
  "components.routes.modals.Deposit.hint":
    "Your internal balance will be credited with tokens equivalent to USDT",

  // ── Адрес пополнения ─────────────────────────────────
  "components.routes.modals.DepositAddress.heading":
    "Deposit {currency} ({network})",
  "components.routes.modals.DepositAddress.copied": "Address copied",
  "components.routes.modals.DepositAddress.error":
    "Failed to create the wallet. Please try again later.",
  "components.routes.modals.DepositAddress.retry": "Try again",
  "components.routes.modals.DepositAddress.creating":
    "Generating your deposit address...",
  "components.routes.modals.DepositAddress.address": "Address:",
  "components.routes.modals.DepositAddress.copy": "Copy address",
  "components.routes.modals.DepositAddress.credit": "Crediting:",
  "components.routes.modals.DepositAddress.credit.value": "automatic",

  // ── Вывод (выбор способа) ────────────────────────────
  "components.routes.modals.Withdraw.usdt": "Withdraw USDT (TRC20)",
  "components.routes.modals.Withdraw.crypto": "Withdraw in crypto",
  "components.routes.modals.Withdraw.rub": "Withdraw in RUB (coming soon)",

  // ── Форма вывода ─────────────────────────────────────
  "components.routes.modals.WithdrawForm.heading":
    "Withdraw {currency} ({network})",
  "components.routes.modals.WithdrawForm.creating": "Submitting your request...",
  "components.routes.modals.WithdrawForm.available": "Available",
  "components.routes.modals.WithdrawForm.available.value": "{amount} tokens",
  "components.routes.modals.WithdrawForm.address.label": "Wallet address",
  "components.routes.modals.WithdrawForm.address.placeholder": "Enter address",
  "components.routes.modals.WithdrawForm.amount.label":
    "Withdrawal amount (USD)",
  "components.routes.modals.WithdrawForm.submit": "Withdraw",
  "components.routes.modals.WithdrawForm.error.address.required":
    "Enter a wallet address",
  "components.routes.modals.WithdrawForm.error.address.invalid":
    "Invalid TRC20 address: it must start with “T” and be 34 characters long",
  "components.routes.modals.WithdrawForm.error.amount.required":
    "Enter a withdrawal amount",
  "components.routes.modals.WithdrawForm.error.insufficient":
    "Insufficient funds",
  "components.routes.modals.WithdrawForm.error.wagering":
    "Available for withdrawal: {withdrawable} ₮. Deposits and bonuses must be wagered first — {remaining} ₮ left to bet.",
  "components.routes.modals.WithdrawForm.wagering.hint":
    "Locked until wagered: {locked} ₮. You still need to bet {remaining} ₮.",
  "components.routes.modals.WithdrawForm.error.amount.min":
    "Minimum withdrawal amount: 3 USD",

  // ── Форма создания события ───────────────────────────
  "components.forms.AddEventForm.outcome.maxLength":
    "An outcome must be no longer than 10 characters",
  "components.forms.AddEventForm.date.format": "Enter the date as XX.XX.XXXX",
};
